// extracted by mini-css-extract-plugin
export default {"map__contact":"MapCompany_map__contact__KbGpz"};